// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Traditions_traditions__AjFnq {
  margin-bottom: 100px;
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
@media (max-width: 780px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w {
    gap: 100px;
  }
}
@media (max-width: 550px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w {
    gap: 80px;
  }
}
@media (max-width: 480px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w {
    gap: 60px;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G {
  position: relative;
  background-color: var(--red);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
@media (max-width: 1350px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G {
    gap: 20px;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_index__CPviJ {
  padding: 0 30px 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1350px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_index__CPviJ {
    padding: 0 10px 0 20px;
  }
}
@media (max-width: 640px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_index__CPviJ {
    display: none;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_index__CPviJ h3 {
  font-size: 7.5rem;
  margin: 0;
  font-family: "Rubik Glitch";
  font-weight: 400;
  color: var(--white);
}
@media (max-width: 1350px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_index__CPviJ h3 {
    font-size: 6.8rem;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  padding: 0 20px 0 0;
}
@media (max-width: 780px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 .Traditions_btn__-zKmO {
    position: absolute;
    border: 0;
    top: calc(100% + 15px);
    right: -10px;
  }
}
@media (max-width: 780px) and (max-width: 480px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 .Traditions_btn__-zKmO {
    top: calc(100% + 5px);
    right: -12px;
  }
}
@media (max-width: 640px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 {
    padding: 0 20px 0 5px;
  }
}
@media (max-width: 480px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 {
    padding: 0 10px 0 2px;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 h2 {
  font-family: "Beer money";
  font-size: 2rem;
  font-weight: 400;
}
@media (max-width: 640px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 h2 {
    font-size: 1.9rem;
  }
}
@media (max-width: 480px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 h2 {
    font-size: 1.7rem;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 h2, .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_box_info__AbAE2 p {
  margin: 0;
  color: var(--white);
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_foto__QZtG- img {
  box-sizing: border-box;
  height: 100%;
  max-height: 320px;
  border: 10px solid var(--white);
  border-radius: 50%;
}
@media (max-width: 780px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_foto__QZtG- img {
    border: 8px solid var(--white);
    transform: scale(1.2);
  }
}
@media (max-width: 550px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_foto__QZtG- img {
    border: 5px solid var(--white);
  }
}
@media (max-width: 1350px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_foto__QZtG- {
    max-height: 260px;
    max-width: 260px;
  }
}
@media (max-width: 1080px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_foto__QZtG- {
    max-height: 200px;
    max-width: 200px;
  }
}
@media (max-width: 550px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_foto__QZtG- {
    max-height: 140px;
    max-width: 140px;
  }
}
@media (max-width: 480px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G .Traditions_foto__QZtG- {
    max-height: 100px;
    max-width: 100px;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(odd) {
  margin-right: 100px;
  border-radius: 0 200px 200px 0;
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(odd) .Traditions_foto__QZtG- {
  margin-right: -15px;
}
@media (max-width: 1350px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(odd) {
    margin-right: 40px;
  }
}
@media (max-width: 780px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(odd) {
    margin-right: 20px;
    border-radius: 40px 200px 200px 40px;
  }
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(even) {
  margin-left: 100px;
  flex-direction: row-reverse;
  width: 100%;
  border-radius: 200px 0 0 200px;
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(even) .Traditions_index__CPviJ {
  margin-right: 200px;
}
.Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(even) .Traditions_foto__QZtG- {
  margin-left: -15px;
}
@media (max-width: 1350px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(even) {
    margin-left: 40px;
    width: calc(100% + 60px);
  }
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(even) .Traditions_index__CPviJ {
    margin-right: 150px;
  }
}
@media (max-width: 780px) {
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(even) {
    margin-left: 0px;
    margin-right: 20px;
    flex-direction: row;
    width: 100%;
    border-radius: 40px 200px 200px 40px;
  }
  .Traditions_traditions__AjFnq .Traditions_items__CNL5w .Traditions_item__G6q0G:nth-child(even) .Traditions_index__CPviJ {
    margin-right: 0px;
  }
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx {
  position: fixed;
  inset: 0;
  background: rgba(217, 217, 217, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  z-index: 105;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px;
  max-height: 100%;
  overflow-y: auto;
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_bg_height__V-kUh {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
}
@media (max-width: 640px) {
  .Traditions_traditions__AjFnq .Traditions_popup__bc0Vx {
    padding: 40px 20px;
  }
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD {
  border: 5px solid var(--red);
  background-color: var(--white);
  position: relative;
  margin: 50px 100px;
  padding: 5vh 3rem;
  box-sizing: border-box;
}
@media (max-width: 1420px) {
  .Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD {
    margin: 50px 20px;
  }
}
@media (max-width: 640px) {
  .Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD {
    margin: 0px 0px !important;
    padding: 4vh 1.5rem;
  }
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(26, 24, 47, 0.15);
  border-radius: 5px;
  height: 200px;
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD::-webkit-scrollbar-thumb {
  background: rgba(255, 0, 0, 0.101);
  border-radius: 8px;
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD h2 {
  font-family: "Beer money";
  font-weight: 400;
  margin: 0;
  max-width: 90%;
  font-size: 2rem;
}
@media (max-width: 768px) {
  .Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD h2 {
    max-width: 80%;
  }
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD h2 strong {
  color: var(--red);
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD .Traditions_close__gBQFw {
  position: absolute;
  top: 25px;
  right: 25px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--red);
  border-radius: 50%;
  cursor: pointer;
  border: none;
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD .Traditions_close__gBQFw i {
  font-size: 25px;
  color: var(--white);
}
@media (max-width: 480px) {
  .Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD .Traditions_close__gBQFw {
    top: 15px;
    right: 15px;
  }
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD .Traditions_col__ja6zB {
  display: flex;
  align-items: flex-start;
}
@media (max-width: 920px) {
  .Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD .Traditions_col__ja6zB {
    flex-direction: column;
  }
}
.Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD .Traditions_col__ja6zB .Traditions_foto_card__dEeGW {
  width: 35%;
  max-width: 400px;
}
@media (max-width: 920px) {
  .Traditions_traditions__AjFnq .Traditions_popup__bc0Vx .Traditions_box_popup__6xJHD .Traditions_col__ja6zB .Traditions_foto_card__dEeGW {
    margin: 0 auto;
    width: 100%;
    max-width: 350px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Traditions/Traditions.module.scss"],"names":[],"mappings":"AAEA;EACG,oBAAA;AADH;AAGG;EACG,aAAA;EACA,sBAAA;EACA,SAAA;AADN;AAGM;EALH;IAMM,UAAA;EAAP;AACF;AACM;EARH;IASM,SAAA;EAEP;AACF;AAAM;EAZH;IAaM,SAAA;EAGP;AACF;AADM;EACG,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAGT;AADS;EARH;IASM,SAAA;EAIV;AACF;AAFS;EACG,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAIZ;AAFY;EANH;IAOM,sBAAA;EAKb;AACF;AAHY;EAVH;IAWM,aAAA;EAMb;AACF;AAJY;EACG,iBAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AAMf;AAJe;EAPH;IAQM,iBAAA;EAOhB;AACF;AAHS;EACG,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAKZ;AAHY;EACG;IACG,kBAAA;IACA,SAAA;IACA,sBAAA;IACA,YAAA;EAKhB;AACF;AAJkB;EANH;IAOM,qBAAA;IACA,YAAA;EAOnB;AACF;AAHY;EAvBH;IAwBM,qBAAA;EAMb;AACF;AAJY;EA3BH;IA4BM,qBAAA;EAOb;AACF;AALY;EACG,yBAAA;EACA,eAAA;EACA,gBAAA;AAOf;AALe;EALH;IAMM,iBAAA;EAQhB;AACF;AANe;EATH;IAUM,iBAAA;EAShB;AACF;AAPY;EACG,SAAA;EACA,mBAAA;AASf;AAJY;EACG,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;AAMf;AAJe;EAPH;IAQM,8BAAA;IACA,qBAAA;EAOhB;AACF;AALe;EAZH;IAaM,8BAAA;EAQhB;AACF;AALY;EAlBH;IAmBM,iBAAA;IACA,gBAAA;EAQb;AACF;AANY;EAvBH;IAwBM,iBAAA;IACA,gBAAA;EASb;AACF;AAPY;EA5BH;IA6BM,iBAAA;IACA,gBAAA;EAUb;AACF;AARY;EAjCH;IAkCM,iBAAA;IACA,gBAAA;EAWb;AACF;AANM;EACG,mBAAA;EACA,8BAAA;AAQT;AAPS;EACG,mBAAA;AASZ;AAPS;EANH;IAOM,kBAAA;EAUV;AACF;AARS;EAVH;IAWM,kBAAA;IACA,oCAAA;EAWV;AACF;AAPM;EACG,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,8BAAA;AAST;AAPS;EACG,mBAAA;AASZ;AAPS;EACG,kBAAA;AASZ;AANS;EAbH;IAcM,iBAAA;IACA,wBAAA;EASV;EARU;IACG,mBAAA;EAUb;AACF;AANS;EAtBH;IAuBM,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;IACA,oCAAA;EASV;EAPU;IACG,iBAAA;EASb;AACF;AAJG;EACG,eAAA;EACA,QAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAMN;AAJM;EACG,8BAAA;EACA,aAAA;EACA,mBAAA;AAMT;AAHM;EAnBH;IAoBM,kBAAA;EAMP;AACF;AAJM;EACG,4BAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAMT;AAJS;EARH;IASM,iBAAA;EAOV;AACF;AALS;EAZH;IAaM,0BAAA;IACA,mBAAA;EAQV;AACF;AANS;EACG,UAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;AAQZ;AALS;EACM,kCAAA;EACA,kBAAA;AAOf;AAJS;EACG,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAMZ;AAJY;EAPH;IAQM,cAAA;EAOb;AACF;AALY;EACG,iBAAA;AAOf;AAHS;EACG,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAKZ;AAHY;EACG,eAAA;EACA,mBAAA;AAKf;AAFY;EAlBH;IAmBM,SAAA;IACA,WAAA;EAKb;AACF;AAFS;EACG,aAAA;EACA,uBAAA;AAIZ;AAFY;EAJH;IAKM,sBAAA;EAKb;AACF;AAHY;EACG,UAAA;EACA,gBAAA;AAKf;AAHe;EAJH;IAKM,cAAA;IACA,WAAA;IACA,gBAAA;EAMhB;AACF","sourcesContent":["\r\n\r\n.traditions{\r\n   margin-bottom: 100px;\r\n\r\n   .items {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 30px;\r\n\r\n      @media (max-width: 780px) {\r\n         gap: 100px;\r\n      }\r\n      @media (max-width: 550px) {\r\n         gap: 80px;\r\n      }\r\n\r\n      @media (max-width: 480px) {\r\n         gap: 60px;\r\n      }\r\n\r\n      .item {\r\n         position: relative;\r\n         background-color: var(--red);\r\n         box-sizing: border-box;\r\n         display: flex;\r\n         justify-content: space-between;\r\n         gap: 40px;\r\n\r\n         @media (max-width: 1350px) {\r\n            gap: 20px;\r\n         }\r\n\r\n         .index {\r\n            padding: 0 30px 0 20px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n\r\n            @media (max-width: 1350px) {\r\n               padding: 0 10px 0 20px;\r\n            }\r\n\r\n            @media (max-width: 640px) {\r\n               display: none;\r\n            }\r\n\r\n            h3 {\r\n               font-size: 7.5rem;\r\n               margin: 0;\r\n               font-family: 'Rubik Glitch';\r\n               font-weight: 400;\r\n               color: var(--white);\r\n\r\n               @media (max-width: 1350px) {\r\n                  font-size: 6.8rem;\r\n               }\r\n            }\r\n         }\r\n\r\n         .box_info{\r\n            width: 100%;\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n            align-items: flex-start;\r\n            gap: 20px;\r\n            padding: 0 20px 0 0;\r\n\r\n            @media (max-width: 780px) {\r\n               .btn{\r\n                  position: absolute;\r\n                  border: 0;\r\n                  top: calc(100% + 15px);\r\n                  right: -10px;\r\n\r\n                  @media (max-width: 480px) {\r\n                     top: calc(100% + 5px);\r\n                     right: -12px;\r\n                  }\r\n               }\r\n            }\r\n\r\n            @media (max-width: 640px) {\r\n               padding: 0 20px 0 5px;\r\n            }\r\n\r\n            @media (max-width: 480px) {\r\n               padding: 0 10px 0 2px;\r\n            }\r\n\r\n            h2{\r\n               font-family: \"Beer money\";\r\n               font-size: 2rem;\r\n               font-weight: 400;\r\n\r\n               @media (max-width: 640px) {\r\n                  font-size: 1.9rem;\r\n               }\r\n\r\n               @media (max-width: 480px) {\r\n                  font-size: 1.7rem;\r\n               }\r\n            }\r\n            h2, p {\r\n               margin: 0;\r\n               color: var(--white);\r\n            }\r\n         }\r\n\r\n         .foto{\r\n            img{\r\n               box-sizing: border-box;\r\n               height: 100%;\r\n               max-height: 320px;\r\n               border: 10px solid var(--white);\r\n               border-radius: 50%;\r\n\r\n               @media (max-width: 780px) {\r\n                  border: 8px solid var(--white);\r\n                  transform: scale(1.2);\r\n               }\r\n\r\n               @media (max-width: 550px) {\r\n                  border: 5px solid var(--white);\r\n               }\r\n            }\r\n\r\n            @media (max-width: 1350px) {\r\n               max-height: 260px;\r\n               max-width: 260px;\r\n            }\r\n\r\n            @media (max-width: 1080px) {\r\n               max-height: 200px;\r\n               max-width: 200px;\r\n            }\r\n\r\n            @media (max-width: 550px) {\r\n               max-height: 140px;\r\n               max-width: 140px;\r\n            }\r\n\r\n            @media (max-width: 480px) {\r\n               max-height: 100px;\r\n               max-width: 100px;\r\n            }\r\n         }\r\n      }\r\n\r\n      // 1\r\n      .item:nth-child(odd) {\r\n         margin-right: 100px;\r\n         border-radius: 0 200px 200px 0;\r\n         .foto{\r\n            margin-right: -15px;\r\n         }\r\n         @media (max-width: 1350px) {\r\n            margin-right: 40px;\r\n         }\r\n\r\n         @media (max-width: 780px) {\r\n            margin-right: 20px;\r\n            border-radius: 40px 200px 200px 40px;\r\n         }\r\n      }\r\n\r\n      // 2\r\n      .item:nth-child(even) {\r\n         margin-left: 100px;\r\n         flex-direction: row-reverse;\r\n         width: 100%;\r\n         border-radius: 200px 0 0 200px;\r\n\r\n         .index{\r\n            margin-right: 200px;\r\n         }\r\n         .foto{\r\n            margin-left: -15px;\r\n         }\r\n\r\n         @media (max-width: 1350px) {\r\n            margin-left: 40px;\r\n            width: calc(100% + 60px);\r\n            .index{\r\n               margin-right: 150px;\r\n            }\r\n         }\r\n\r\n\r\n         @media (max-width: 780px) {\r\n            margin-left: 0px;\r\n            margin-right: 20px;\r\n            flex-direction: row;\r\n            width: 100%;\r\n            border-radius: 40px 200px 200px 40px;\r\n\r\n            .index{\r\n               margin-right: 0px;\r\n            }\r\n         }\r\n      }\r\n   }\r\n\r\n   .popup{\r\n      position: fixed;\r\n      inset: 0;\r\n      background: rgba(217, 217, 217, 0.1);\r\n      backdrop-filter: blur(10px);\r\n      z-index: 105;\r\n      display: flex;\r\n      align-items: flex-start;\r\n      justify-content: center;\r\n      padding: 40px;\r\n      max-height: 100%;\r\n      overflow-y: auto;\r\n\r\n      .bg_height{\r\n         min-height: calc(100vh - 80px);\r\n         display: flex;\r\n         align-items: center;\r\n      }\r\n\r\n      @media (max-width: 640px) {\r\n         padding: 40px 20px;\r\n      }\r\n\r\n      .box_popup{\r\n         border: 5px solid var(--red);\r\n         background-color: var(--white);\r\n         position: relative;\r\n         margin: 50px 100px;\r\n         padding: 5vh 3rem;\r\n         box-sizing: border-box;\r\n\r\n         @media (max-width: 1420px) {\r\n            margin: 50px 20px;\r\n         }\r\n\r\n         @media (max-width: 640px) {\r\n            margin: 0px 0px !important;\r\n            padding: 4vh 1.5rem;\r\n         }\r\n\r\n         &::-webkit-scrollbar {\r\n            width: 8px;\r\n            background-color: rgba(26, 24, 47, 0.15);\r\n            border-radius: 5px;\r\n            height: 200px;\r\n         }\r\n         \r\n         &::-webkit-scrollbar-thumb {\r\n               background: rgba(255, 0, 0, 0.101);\r\n               border-radius: 8px;\r\n         }\r\n\r\n         h2{\r\n            font-family: \"Beer money\";\r\n            font-weight: 400;\r\n            margin: 0;\r\n            max-width: 90%;\r\n            font-size: 2rem;\r\n\r\n            @media (max-width: 768px) {\r\n               max-width: 80%;\r\n            }\r\n\r\n            strong {\r\n               color: var(--red);\r\n            }\r\n         }\r\n\r\n         .close{\r\n            position: absolute;\r\n            top: 25px;\r\n            right: 25px;\r\n            padding: 4px 6px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            background-color: var(--red);\r\n            border-radius: 50%;\r\n            cursor: pointer;\r\n            border: none;\r\n\r\n            i{\r\n               font-size: 25px;\r\n               color: var(--white);\r\n            }\r\n\r\n            @media (max-width: 480px) {\r\n               top: 15px;\r\n               right: 15px;\r\n            }\r\n         }\r\n\r\n         .col{\r\n            display: flex;\r\n            align-items: flex-start;\r\n\r\n            @media (max-width: 920px) {\r\n               flex-direction: column;\r\n            }\r\n\r\n            .foto_card{\r\n               width: 35%;\r\n               max-width: 400px;\r\n\r\n               @media (max-width: 920px) {\r\n                  margin: 0 auto;\r\n                  width: 100%;\r\n                  max-width: 350px;\r\n               }\r\n            }\r\n         }\r\n      }\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"traditions": `Traditions_traditions__AjFnq`,
	"items": `Traditions_items__CNL5w`,
	"item": `Traditions_item__G6q0G`,
	"index": `Traditions_index__CPviJ`,
	"box_info": `Traditions_box_info__AbAE2`,
	"btn": `Traditions_btn__-zKmO`,
	"foto": `Traditions_foto__QZtG-`,
	"popup": `Traditions_popup__bc0Vx`,
	"bg_height": `Traditions_bg_height__V-kUh`,
	"box_popup": `Traditions_box_popup__6xJHD`,
	"close": `Traditions_close__gBQFw`,
	"col": `Traditions_col__ja6zB`,
	"foto_card": `Traditions_foto_card__dEeGW`
};
export default ___CSS_LOADER_EXPORT___;
